import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RegistrantStatus } from '../accounts/model/RegistrantStatus';
import { EnglishQualificationType, RegistrationRoute, RestorationDeclarationQuestion, ReturnToRegisterDetails } from './model/ReturnToRegisterDetails';
import { PreregApplicationService } from './service/prereg.service';
import { RevalidationItemType } from '../revalidation/model/RevalidationItemType';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { RevalidationStatus } from '../revalidation/model/RevalidationStatus';
import { CrmSubmissionStatus } from '../queries/model/crmSubmissionStatus';
import { CrmRemediationStatus } from '../revalidation/model/CrmRemediationStatus';
import { CrmNoirAndNorStatus } from '../queries/model/crmNoirAndNorStatus';
import { CrmReviewAndFeedbackStatus } from '../revalidation/model/CrmReviewAndFeebackStatus';
import { ConfirmDialogComponent } from '../shared/confirmDialog.component';

export interface EntryElement{
  title: string;
  type: RevalidationItemType;
  isCompleted: string;
  isSubmitted: string;
  lastUpdatedOn: string;
}

@Component({
  selector: 'app-return-to-register-application',
  templateUrl: './returnToRegisterApplication.component.html',
  styleUrls: ['./application.scss','./returnToRegisterApplication.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed,void', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ReturnToRegisterComponent implements OnInit {

  @Input()application!:ReturnToRegisterDetails; 
  englishCertificateOption!: string;
  registrationStatus!: string;
  Q10!:RestorationDeclarationQuestion;
  Q11!:RestorationDeclarationQuestion;
  q8Title="Question 8"
  q9Title="Question 9"
  registration: any;
  registrationNumber: any;
  Q10Address!: string;
  Q11Address!: string;  
  requestedTittle!:string;
  requestedFirstName!:string;
  requestedMiddleName!:string;
  requestedLastName!: string;
  revalidationDetails!: ReturnToRegisterDetails['revalidationDetails'];
  tabsList = ['Application details','Revalidation details'];
  questionGroups = [];
  entries: any[] = [];
  columnsToDisplay = ['title','type','isCompleted','isSubmitted','lastUpdatedOn'];
  columnsToDisplayWithExpand = [...this.columnsToDisplay, 'expand'];
  itemViewed: EntryElement | null = null;
  entryDetails: any = null;
  displayRevalidationRecords = true;
  submissionRejectedSuccessfully!: boolean;
  loading: boolean = false;
  revalidationRejectDateTime: string | null = null;

  constructor(private dialog: MatDialog,
    private preregService: PreregApplicationService) { }

    get fullName(){
      let first,middle,last;
      first=this.application.personalDetails.forenames!=null?this.application.personalDetails.forenames:"";
      middle=this.application.personalDetails.middleName!=null?this.application.personalDetails.middleName:"";
      last=this.application.personalDetails.surname!=null?this.application.personalDetails.surname:"";
      if(first=="" && middle=="" && last=="" ){
        return "-";
      }
      return first +" "+middle +" "+last;
     }
   
  fetchEntryDetailsByTitle(item: EntryElement) {
    this.entryDetails = (item as any)?.details ?? null;
    this.displayRevalidationRecords = false;
  }

  getRevalidationItemType(type: RevalidationItemType) {
    return RevalidationItemType[type];
  }

  getItem(item: string, value: any) {
    let itemValue = value;
    if(item === 'type') itemValue = this.getRevalidationItemType(value);
    if(item === 'lastUpdatedOn') itemValue = this.getUTCdate(value);
    return itemValue;
  }

  getColumn(column: string) {
    if(column === 'isCompleted' || column === 'isSubmitted') return column+' ?';
    else return column;
  }
  
  getUTCdate(value: string) {
    const date = new Date(value.split('T')[0] ?? value);
    const ticks = date.getTime();
    const offset = date.getTimezoneOffset();
    const adjusted = ticks + (offset * 60 * 1000);
    const adjustedDate = new Date(adjusted);
    const year = adjustedDate.getFullYear();
    let month = (adjustedDate.getMonth() + 1).toString();
    if (month.length === 1) {
      month = '0' + month;
    }
    let day = adjustedDate.getDate().toString();
    if (day.length === 1) {
      day = '0' + day;
    }


    return `${day}/${month}/${year}`;
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView();
  }

  onRowClick(itemViewed: any, item: any) {
    return itemViewed === item ? null : item;
  }

  setElementSelected(elem: any, _expElem: any) {
    this.questionGroups = elem?.form?.questionGroups || [];
  }

  ngOnInit(): void {  
    this.application.form.attachments.forEach((doc:any)=>{
      doc.url=doc.downloadUrl;// adding url proprty to attachments array
    });
    this.revalidationDetails = this.application.revalidationDetails;
    const revalidationEntries = this.application?.revalidationDetails?.entries;
    this.entries = Array.isArray(revalidationEntries) ? revalidationEntries : [];
    const englishCertificateOption = this.application?.form?.returnToRegisterDetail?.englishCertificateOption;
    this.englishCertificateOption = englishCertificateOption != null
      ? (EnglishQualificationType[Number(englishCertificateOption)] ?? '-')
      : '-';
    this.revalidationRejectDateTime = this.application?.form?.returnToRegisterDetail?.revalidationRejectDateTime || null;  
    this.registration=this.application.personalDetails.registration;
    if(this.registration){
     this.registrationNumber = this.registration.registrationNumber;      
     this.registrationStatus =RegistrantStatus[this.registration.registrationStatus] || "-";
    }
   this.application.form.restorationDeclarations.forEach(element => {
    if(element.questionName=="Q10"){
        this.Q10=element;     
        this.Q10Address=element.employerAddress!=null?this.toString(element.employerAddress):"-";       
    }
    else{
        this.Q11=element;
        this.Q11Address=element.employerAddress!=null?this.toString(element.employerAddress):"-";
    }
   
      this.requestedTittle=this.application?.form?.returnToRegisterDetail?.title?.name;
      this.requestedFirstName=this.application?.form?.returnToRegisterDetail?.forenames;
      this.requestedMiddleName=this.application?.form?.returnToRegisterDetail?.middleName;
      this.requestedLastName=this.application?.form?.returnToRegisterDetail?.surname;
   });
  }

  getRevalidationStatus(status: number) {
    return RevalidationStatus[status] || '-';
  }

  getSubmissionStatus(status: number) {
    return CrmSubmissionStatus[status] || '-';
  }

  getRemediationStatus(status: number) {
    return CrmRemediationStatus[status] || '-';
  }

  getNoirAndNorStatus(status: number) {
    return CrmNoirAndNorStatus[status] || '-';
  }

  getReviewAndFeedbackStatus(status: number) {
    return CrmReviewAndFeedbackStatus[status] || '-';
  }

  get isSubmissionRejected() {
    return !!this.revalidationRejectDateTime;
  }

  rejectSubmission() {

    let dialogMessage = '';
    this.loading = true;
    this.preregService.rejectSubmission(this.application.form.id, this.revalidationDetails.id).subscribe( 
    result=> {
      dialogMessage = 'Revalidation submission rejected successfully';
      this.submissionRejectedSuccessfully = true;
      this.openConfirmationDialog(dialogMessage);
      this.loading = false;
    }, error => {
      this.submissionRejectedSuccessfully = false;
      dialogMessage = 'Revalidation submission rejection failed. Please try again.';
      console.error(error);
      this.openConfirmationDialog(dialogMessage);
      this.loading = false;
    });
  }

  getObjectLength(obj: object) {
    return Object.keys(obj).length;
  }
  private concat(item: string) {
    return item ? item + ', ' : '';
  }
  
  toString(address: NonNullable<RestorationDeclarationQuestion['employerAddress']>) {
    return this.concat(address.line1) +
    this.concat(address.line2) +
    this.concat(address.line3) +
    this.concat(address.town) +
    this.concat(address.county) +
    address.country + ' ' +
    address.postcode;

  }

  get isRouteEEA(): boolean {
    return this.registration?.registrationRoute === RegistrationRoute.EEA;
  }

  askConfirmationDialog() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        data: {
            title: 'Confirm Rejection',
            message: `Are you sure you want to reject the revalidation submission?`
        }
    });
    dialogRef.afterClosed().subscribe((userResponse) => {
        if (userResponse) this.rejectSubmission();
    });
    }

    openConfirmationDialog(message: string){
      this.dialog.open(ConfirmDialogComponent, {
        data: {
          allowCancel: false,
          allowNext: false,
          title: `Rejection submission status`,
          message: `${message}`
        }
      });
    }
}